import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import {
  LayoutActionLoadError,
  LayoutActionSaveSuccess,
  LayoutActionVersionError
} from '../../../shared/store/actions/layout.action';
import { ShelfReplenishmentPhotoService } from '../service/shelf-replenishment-photo.service';
import { shelfReplenishmentPhotoAction } from './shelf-replenishment-photo.actions';

@Injectable()
export class ShelfReplenishmentPhotoEffects {
  getShelReplenishmentPhotoListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shelfReplenishmentPhotoAction.shelfReplenishmentPhotoListRequest),
      tap(action =>
        this.logger.debug('@Effect Load Shelf Replenishment Photo List Requested: ' + JSON.stringify(action))
      ),
      switchMap(payload => {
        return this.shelfReplenishmentPhotoService.shelfReplenishmentPhotoListRequest(payload.criteriaObject).pipe(
          map(data => shelfReplenishmentPhotoAction.shelfReplenishmentPhotoListResponse({ data })),
          catchError(err => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });

  getShelReplenishmentPhotoTaskSummaryRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shelfReplenishmentPhotoAction.shelfReplenishmentPhotoTaskSummaryRequest),
      tap(action =>
        this.logger.debug('@Effect Load Shelf Replenishment Photo Task Summary Requested: ' + JSON.stringify(action))
      ),
      switchMap(() => {
        return this.shelfReplenishmentPhotoService.shelfReplenishmentPhotoTaskSummaryRequest().pipe(
          map(response => shelfReplenishmentPhotoAction.shelfReplenishmentPhotoTaskSummaryResponse({ response })),
          catchError(err => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });

  shelfReplenishmentPhotoView$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shelfReplenishmentPhotoAction.shelfReplenishmentPhotoViewRequest),
      tap(action =>
        this.logger.debug(
          '@Effect [Shelf Replenishment Photo Action] Shelf Replenishment Photo Action View Request: ' +
            JSON.stringify(action)
        )
      ),
      switchMap(payload => {
        return this.shelfReplenishmentPhotoService.shelfReplenishmentPhotoView({ payload }).pipe(
          map(response => {
            return shelfReplenishmentPhotoAction.shelfReplenishmentPhotoViewResponse({ response });
          }),
          catchError(error => of(new LayoutActionLoadError(error)))
        );
      })
    );
  });
  shelfReplenishmentPhotoActionSubmitRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shelfReplenishmentPhotoAction.shelfReplenishmentPhotoActionSubmitRequest),
      tap(action =>
        this.logger.debug(
          '@Effect [Shelf Replenishment Photo Action] Shelf Replenishment Photo Action Submit Request: ' +
            JSON.stringify(action)
        )
      ),
      switchMap(payload => {
        return this.shelfReplenishmentPhotoService
          .shelfReplenishmentPhotoActionSubmitRequest({ payload: payload.payload })
          .pipe(
            map(
              () =>
                new LayoutActionSaveSuccess({
                  isSuccess: true,
                  title: 'Success',
                  message: 'Shelf Replenishment Photo has been submitted.'
                })
            ),
            catchError(error =>
              error && error.error && error.error.code === '00001'
                ? of(new LayoutActionVersionError(true))
                : of(new LayoutActionLoadError(error))
            )
          );
      })
    );
  });
  shelfReplenishmentPhotoActionHistoryRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shelfReplenishmentPhotoAction.shelfReplenishmentPhotoActionHistoryRequest),
      tap(action =>
        this.logger.debug(
          '@Effect [Shelf Replenishment Photo Action] Shelf Replenishment Photo Action History Request: ' +
            JSON.stringify(action)
        )
      ),
      switchMap(payload => {
        return this.shelfReplenishmentPhotoService.shelfReplenishmentPhotoActionHistoryRequest({ payload }).pipe(
          map(response => {
            return shelfReplenishmentPhotoAction.shelfReplenishmentPhotoActionHistoryResponse({ response });
          }),
          catchError(error => of(new LayoutActionLoadError(error)))
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private shelfReplenishmentPhotoService: ShelfReplenishmentPhotoService
  ) {}
}
